<template>
  <div class="phrase-overlay" :style="drawer ? 'z-index:1000' : 'z-index:-30000; opacity:0'" v-if="drawer">
    <transition name="fade">
      <div class="tag-dialog">
        <div class="newmessage-title">
          <div class="flex-row">
            <div>タグを管理</div>
            <div style="font-weight:700;">({{ tag_list.length }}件)</div>
          </div>
          <div class="flex-space"></div>
          <div class="newmessage-button" @click="closeDrawer()">
            <font-awesome-icon :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="tag-dialog-title">
          <div class="flex-row">
            <div>タグの編集、削除を行えます。</div>
          </div>
          <div class="flex-space"></div>
          <el-dropdown trigger="click" style="margin-left: 20px;">
            <el-button type="default" size="mini" class="report-media-sort-button" style="width:auto" :disabled="tag_list.length === 0">
              {{ sort_description }}
              <font-awesome-icon icon="caret-down" style="margin-left:5px" />
            </el-button>
            <el-dropdown-menu slot="dropdown" style="z-index:50000">
              <el-dropdown-item @click.native="sortBy('created_at', 'desc', 'タグ作成日が新しい順')">タグ作成日が新しい順</el-dropdown-item>
              <el-dropdown-item @click.native="sortBy('created_at', 'asc', 'タグ作成日が古い順')">タグ作成日が古い順</el-dropdown-item>
              <el-dropdown-item @click.native="sortBy('added_num', 'desc', 'タグ付け数が多い順')">タグ数が多い順</el-dropdown-item>
              <el-dropdown-item @click.native="sortBy('added_num', 'asc', 'タグ付け数が少ない順')">タグ数が少ない順</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="tag-dialog-box" v-loading="loading" v-if="loading"></div>
        <div class="tag-dialog-box" v-else-if="tag_list.length >= 1">
            <div class="customize-tag-suggest-box admin" v-for="(tag, index) in tag_list" :key="tag.id">
              <div v-if="edit_index == index">
                <tagDrawerInput :tag="tag" @editTag="editTag" @closeEditTag="closeEditTag" />
              </div>
              <div class="customize-tag small" v-else>{{ tag.tag_name }}</div>
              <div class="flex-space"></div>
              <div class="tag-dialog-button-wrap" :class="edit_index == index ? 'visible' : ''">
                <div class="tag-dialog-button" @click="openEditTag(tag.id, index)"><font-awesome-icon :icon="['far', 'pen']" /></div>
                <div class="tag-dialog-button" @click="deleteTag(tag.id, tag.added_num)"><font-awesome-icon :icon="['far', 'trash-alt']" /></div>
              </div>
              <div style="margin-left:15px">
                <span>{{ tag.added_num }}</span>
              </div>
            </div>

        </div>
        <div class="tag-dialog-box" v-else>
          <div class="no-customize-tag">
            <img src="../../assets/search_image.png" style="opacity:0.5" alt />
            <div style="font-size:14px; font-weight:700; margin-bottom:10px;">タグがありません</div>
            <div style="font-size:11px">タグを追加してリストを効率的に管理しましょう</div>
          </div>
        </div>

        <div class="list-create-footer">
          <el-input size="small" v-model="new_tag" placeholder="新しいタグを追加" style="width:200px;margin-right:10px"></el-input>
          <el-button size="small" type="primary" @click="createTag()" :disabled="!new_tag">タグを追加</el-button>
          <div class="flex-space"></div>
          <el-button size="small" @click="closeDrawer()">閉じる</el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import tagDrawerInput from "./tag_drawer_input.vue";

const root = process.env.VUE_APP_API;
const loadTagAPI = root + "/api/list/load_tag";
const deleteTagAPI = root + "/api/list/delete_tag";
const editTagAPI = root + "/api/list/edit_tag";
const createTagAPI = root + "/api/list/create_tag";

export default {
  name: "tagDrawer",
  props: {
    drawer: { type: Boolean, default: false },
  },
  components: {
    tagDrawerInput,
  },
  data() {
    return {
      loading: false,
      tag_list: [],
      edit_index: -1,
      sort_key: "created_at",
      sort_order: "desc",
      sort_description: "タグ作成日が新しい順",
      new_tag: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.loadTag();
  },
  methods: {
    loadTag() {
      this.loading = true;
      this.axios
        .get(loadTagAPI, {
          params: {
            token: this.token,
            sort_key: this.sort_key,
            sort_order: this.sort_order,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;
          setTimeout(() => {
            this.loading = false;
          }, 300);
        })
    },
    sortBy(sort_key, sort_order, description) {
      this.tag_list = [];
      this.sort_description = description;
      this.sort_key = sort_key;
      this.sort_order = sort_order;
      this.loadTag();
    },
    openEditTag(tag_id, index) {
      this.edit_index = index;
      setTimeout(() => {
        document.getElementById(tag_id).focus();
      }, 100);
    },
    closeEditTag() {
      this.edit_index = -1;
    },
    editTag(tag_id, tag_name) {
      var params = new URLSearchParams();
      params.append("tag_id", tag_id);
      params.append("tag_name", tag_name);
      params.append("token", this.token);
      this.axios
        .post(editTagAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: 'タグ名を変更しました',
            });
            this.edit_index = -1;
            this.$emit("loadTag");
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message,
            });
          }
        })
    },
    deleteTag(tag_id, added_num) {
      this.$confirm(added_num + "個のリストにこのタグが追加されています。<br/>※この操作は取り消せません。", "タグを削除しますか？", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
      .then(() => {
        var params = new URLSearchParams();
        params.append("tag_id", tag_id);
        params.append("token", this.token);
        this.axios
          .post(deleteTagAPI, params)
          .then(() => {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "タグを削除しました",
            });
            this.$emit("loadTag");
            this.$emit("loadList");
            this.loadTag();
          })
        })
    },
    createTag() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("tag_name", this.new_tag);
      this.axios
        .post(createTagAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.new_tag = "";
            this.$emit("loadTag");
            this.loadTag();
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message,
            });
          }
        });
    },
    closeDrawer() {
      this.$emit("closeDrawer");
    },
  },
  watch: {
    drawer() {
      if (this.drawer) {
        this.new_tag = "";
        this.sort_description = "タグ作成日が新しい順";
        this.sort_key = "created_at";
        this.sort_order = "desc";
        this.loadTag();
      }
    },
  },
};
</script>
